import { ObjectSchema, number, object, string, boolean, date } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { Mimic, MimicProfile } from './../../models/mimic';
yup.setLocale(locale);

export function mimicValidator(): ObjectSchema<Mimic> {
    return object({
        id: string().uuid().nonNullable().strict(),
        folderId: string().uuid().nullable().strict(),
        svgcontent: string().nonNullable().strict(),
        name: string().nonNullable().required().strict(),
        vesselId: string().uuid().required().nonNullable().strict(),
        profile: profileValidator().strict().required().noUnknown(),
        createdAt: date().nonNullable().strict(),
        updatedAt: date().nonNullable().strict(),
        locked: boolean().nullable().strict().required(),
        userId: string().nullable().strict().notRequired(),
        index: number().nonNullable().strict(),
    })
        .strict()
        .noUnknown() as ObjectSchema<Mimic>;
}

export function mimicNameValidator() {
    return object({
        name: string().nonNullable().required().max(40, 'errors.validation.generic.above-maximum').strict(),
    });
}

export function profileValidator(): ObjectSchema<MimicProfile> {
    return object({
        width: number().nonNullable().required().strict(),
        height: number().nonNullable().required().strict(),
        bkcolor: string().nonNullable().required().strict(),
        margin: number().nonNullable().required().strict(),
        allowGrid: boolean().nonNullable().required().strict(),
        color: string().nonNullable().required().strict(),
        grid: number().nonNullable().required().strict(),
    })
        .strict()
        .noUnknown();
}
